let streamPosition = 0;
export const generateUniqueStreamPositon = () => {
    return streamPosition++;
}

export const getCurrentOrder = () => {
    return streamPosition;
}